import { render } from "./Watermark.vue?vue&type=template&id=1b855f00&scoped=true&ts=true"
import script from "./Watermark.vue?vue&type=script&lang=ts"
export * from "./Watermark.vue?vue&type=script&lang=ts"

import "./Watermark.vue?vue&type=style&index=0&id=1b855f00&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b855f00"]])

export default __exports__